import { Component, OnInit } from '@angular/core';
import { PartnerService, ScreenService } from '@app/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router, UrlTree } from '@angular/router';
import { GetParams } from '@app/shared';
import { AuthService } from '../../../core/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-callback',
  standalone: false,

  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.css',
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private screenService: ScreenService,
    private oidcSecurityService: OidcSecurityService,
    private router: Router
  ) {
    screenService.isAuthenticating = true;
  }

  ngOnInit(): void {
    this.oidcSecurityService
      .checkAuth(undefined, `0-${environment.clientId}`)
      .subscribe({
        next: (loginResponse) => {
          if (loginResponse.isAuthenticated) {
            const currentPathname =
              localStorage.getItem('currentPathname') || '/home';
            const cleanUrl: UrlTree = this.router.parseUrl(currentPathname);
            this.router
              .navigateByUrl(cleanUrl)
              .then(() => (this.screenService.isAuthenticating = false));
          }
        },
      });
  }
}
